module.exports = __webpack_public_path__ + "img/check.07fef356.svg";